import { gql } from '@apollo/client';

export const FILTERED_LAYOUTS_AND_INSIGHTS = gql`
  query FilteredDashboardLayoutsInsights($input: DashboardLayoutFilterArgs!) {
    layouts: getDashboardLayoutsOrInsights(input: $input) {
      __typename
      ... on DashboardLayout {
        id
        dashboardName: name
        createdAt
        assignedTo {
          id
        }
        category
        isDefault
        createdBy: creator {
          id
          firstName
          lastName
        }
      }
      ... on Insight {
        id
        insightName: name
        users {
          id
        }
        createdOn
        createdBy {
          id
          firstName
          lastName
        }
        tags {
          id
          name
        }
        currentOrganisationUsers {
          id
        }
      }
    }
  }
`;
